<template>
    <article class="appointment-physician">
        <div class="appointment-physician__avatar">
            <common-user-avatar :user="physician" size="user-menu"></common-user-avatar>
        </div>

        <p class="appointment-physician__role">
            {{ $t('common.practice_type.physician') }}
        </p>

        <p class="appointment-physician__name">
            <common-user-name :user="physician"></common-user-name>
        </p>

        <template v-if="isSpecialityDisplayed">
            <p class="appointment-physician__specialities">
                {{ $get(physician, 'specialities.0.speciality.name') }}
            </p>
        </template>

        <template v-if="isPhoneNumberDisplayed && physician.phone">
            <p class="appointment-physician__contact">
                <common-icon-info icon="phone" size="small">
                    {{ physician.phone }}
                </common-icon-info>
            </p>
        </template>
    </article>
</template>

<script>
    export default {
        props: {
            physician: { type: Object, required: true },
            isSpecialityDisplayed: { type: Boolean, default: true },
            isPhoneNumberDisplayed: { type: Boolean, default: true },
        },
    }
</script>
